import {
  action, autorun, computed, makeAutoObservable, makeObservable, observable, runInAction, toJS,
} from 'mobx';
import { isDate } from 'date-fns';
import { v4 as uuidv4 } from 'uuid';
import api from '../../api';

export const monthsArray = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'];

export class StrategyStore {
  isLoading = false;
  planResults = [];

  filters = {
    dateResults: null,
    dateMilestones: (new Date()).getFullYear(),
    status: null,
  };

  trls = [];

  isStrategyContainsResults = false;

  openedTables = [];
  openedModes = []

  currentCommentObject = null;

  constructor() {
    makeAutoObservable(this);
    // autorun(()=>this.addPlanResults())
  }

  changeSyncFilter(name, value){
    this.filters[name] = value !== 'null' ? value : null;
    
  }

  async changeFilter(name, value, requests) {
    this.changeSyncFilter(name, value)
    await requests.updateAllPlanResults();
  }

  clearFilters() {
    for (let filter in this.filters) {
      this.filters[filter] = null
    }
  }

  setCurrentCommentObject(id, status, value) {
    this.currentCommentObject = {
      id,
      status,
      value,
    };

    // const tmp = id?.toString().split(':')
    // if (tmp.length===2){
    //     this.currentCommentObject.id = +tmp[0]
    //     this.currentCommentObject.milestoneId = +tmp[1]
    // }else {
    //     this.currentCommentObject.id = +id
    //     this.currentCommentObject.milestoneId = null
    // }
  }

  clearCurrentCommentObj() {
    this.currentCommentObject = null;
  }

  getStrategyContainsResults(stratId) {
    return api.get(`/strategies/${stratId}/results`).then((x) => {
      runInAction(() => {
        this.isStrategyContainsResults = x ? x?.length > 0 : false;
      });
      return x;
    });
  }

  setOpenedModes(modes, mode){
    return modes.includes(mode) ? [...modes.filter(value => value !== mode)] : [...modes, mode]
  }

  changeTableStatus(resultId, mode) {
    const current = this.openedTables.findIndex(x => x?.id === resultId)
    const copy = [...this.openedTables]
    if (current === -1) {
      copy.push({ id: resultId, opened: [mode] });
    }
    else{
      copy[current] = {...copy[current], opened: this.setOpenedModes(copy[current].opened, mode)}
    }
    this.openedTables = copy
  }

  changeAllTableStatus(flagOpened = false, modes) {
    const copy = [...this.openedTables];
    this.planResults.map((x) => {
      const findElement = copy.find((y) => y.id === x.id);
      const hasTableData = {
        milestones: (x.milestones || [])
          .filter(milestone => !this.filters.projs || this.filters.projs.length === 0 || milestone.projs.some(proj => this.filters.projs.some(filterProj => filterProj.fullNumber === proj.fullNumber)))
          .length > 0,
        projMilestones: [...x.projMilestones, ...x.milestones.reduce((acc, curr) => [...acc, ...curr.projMilestones], [])]
          .filter(milestone => !this.filters.projs || this.filters.projs.length === 0 || milestone.projs.some(proj => this.filters.projs.some(filterProj => filterProj.fullNumber === proj.fullNumber)))
          .length > 0
      }
      if (findElement) { 
        findElement.opened = flagOpened ?
         [...findElement.opened.filter(value => !modes.includes(value)), ...modes.filter(mode => hasTableData[mode])] :
         findElement.opened.filter(value => !modes.includes(value))
      } else { 
        copy.push({ id: x.id, opened: modes.filter(mode => hasTableData[mode])}); 
      }
    });
    this.openedTables = copy;
  }

  setTrls(fetchData) {
    for (const value of fetchData) {
      value.descr = `${value.id} — ${value.descr}`;
    }
    fetchData = [{ id: null, descr: 'Не указано' }, ...fetchData];
    this.trls = fetchData;
  }

  get fetchStatus() {
    return !!this.trls.length;
  }

  addPlanResults(strategyId) {
    // TODO: push after back (withId)

    // this.planResults.push({name:'',ygt:'',datePlan:'',dateFact:'',description:'',responsible:'',documents:[],proveDocuments:[],mileStones:[]})
    const mileStonesLength = this.planResults?.milestones?.length || 0;
    this.planResults.push({
      // id:uuidv4(),
      // status: 'pending',
      comment: '',
      key: uuidv4(),
      strategyId: Number(strategyId),
      num: this.planResults.length + 1,
      name: '',
      ygtFact: '',
      datePlan: '',
      dateFact: '',
      parent: null,
      parentId: null,
      trl: null,
      trlFactId: null,
      trlId: null,
      yearFact: null,
      yearPlan: null,
      monthPlan: null,
      monthYear: null,
      result: '',
      personsInCharge: [],
      projs: [],
      files: [],
      proveDocuments: [],
      milestones: [],
    });
  }

  deletePlanResults(element) {
    this.planResults = this.planResults.filter((p) => p !== element);
  }

  clearNoSavedPlanResults() {
    this.planResults = this.planResults.filter((x) => x.status !== 'isCreating');
  }

  getFilterStr() {
    const [yearStr, yearMileStr, statusStr, statusMileStr] = [
      this.filters.dateResults ? `&year=${this.filters.dateResults}` : '',
      this.filters.dateMilestones ? `&yearMilestone=${this.filters.dateMilestones}` : '',
      this.filters.statusResult ? `&status=${this.filters.statusResult}` : '',
      this.filters.statusMilestone ? `&statusMilestone=${this.filters.statusMilestone}` : '',
    ];
    return `${this.filters.dateResults !== 'null' ? yearStr : ''}${this.filters.dateMilestones !== 'null' ? yearMileStr : ''}${this.filters.statusResult !== 'null' ? statusStr : ''}${this.filters.statusMilestone !== 'null' ? statusMileStr : ''}`;
  }

  // changeFilter(filter){
  //     filters[filter]
  // }
  get resultLength() {
    return this.planResults.length;
  }

  setPlanResults(value) {

    this.planResults = value;
    this.planResults.forEach((x,index)=>{
      x.files = [...value.find((val)=>x.id===val.id)?.files]
    })
  }

  setCurrentPlanResult(id, value) {
    this.planResults.filter((x) => x.id === id)[0] = value;
    // this.planResults = this.planResults
  }

  changeResultsComment(comment) {
    const currentObj = { ...this.currentCommentObject };
    currentObj.comment = { comment };
    this.currentCommentObject = currentObj;
  }

  changePlanResults(...args) {
    let [element, id, name] = args;
    if ([element, id, name].includes(undefined)) { throw new Error(`Element ${element} or Id ${id} or Name ${name} is undefined`); }
    this.planResults = this.planResults.map((x, y) => {
      if (id === x[typeof id === 'string' ? 'key' : 'id']) {
        if (isDate(element)) {
          if (name.toString().toLowerCase() === 'dateplan') {
            x.monthPlan = element.getMonth();
            x.yearPlan = element.getFullYear();
          } else {
            x.monthFact = element.getMonth();
            x.yearFact = element.getFullYear();
          }
          element = `${monthsArray[element.getMonth()]} ${element.getFullYear()}`;
        }
        x = { ...x, [name]: element };
        return x;
      }
      return x;
    });
  }

  clearStore() {
    this.planResults = [];
    this.filters = {
      dateResults: null,
      dateMilestones: null,
      statusResult: null,
      statusMilestone: null,
    };
    this.trls = [];
    this.isStrategyContainsResults = false;

    this.openedTables = [];

    this.currentCommentObject = null;
  }

  setProjects(projects){
    this.projects = projects
  }
}
